import React, { useContext, useRef } from "react";
import { AppContext } from "../../App";
import { sortById } from "../format/SortByIdTrim";
import "./SummaryMenu.scss";
import formatNumberWithCommas from "../format/formatNumberWithCommas";
import { Link } from "react-router-dom";

const SummaryMenu = () => {
  const { productData } = useContext(AppContext);
  const sortedProductData = sortById(productData);
  const menuRef = useRef(null);

  return (
    <Link to="MenuItems">
      <div ref={menuRef} className="summary-menu">
        {sortedProductData.map((item, index) => (
          <div key={index} className="product-item">
            <p className="product-name">{item.name}</p>
            <p className="product-price">
              {formatNumberWithCommas(item.price)}
            </p>
          </div>
        ))}
      </div>
    </Link>
  );
};

export default SummaryMenu;
